import appStore from 'store';
import api from './api';
import { STATUS_TYPE, PAGINATION } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    announcementList: [],
    totalCount: 0,
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: Number(item),
        label: LANGUAGE[item]
      };
    }),
    pagination: PAGINATION,
    announcementDetail: {},
    announcementDetailDialogVisible: false,
    announcementCategories: [],
    announcementCategoriesOrigin: []
  },
  mutations: {
    setAnnouncementList(state, payload) {
      state.announcementList = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setAnnouncementTotalCount(state, payload) {
      state.totalCount = payload;
    },
    setAnnouncementDetail(state, payload) {
      state.announcementDetail = payload;
    },
    setAnnouncementDetailDialogVisible(state, payload) {
      state.announcementDetailDialogVisible = payload;
    },
    setAnnouncementCategories(state, payload) {
      state.announcementCategories = payload;
    },
    setAnnouncementCategoriesOrigin(state, payload) {
      state.announcementCategoriesOrigin = JSON.parse(JSON.stringify(payload));
    }
  },
  getters: {
    announcementList: (state, getters) =>
      state.announcementList.map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status],
          __language: LANGUAGE[item.language],
          __category: item.categoryId
            ? (
                getters.categoryList.find(
                  category => category.value === item.categoryId
                ) || {}
              ).label
            : ''
        };
      }),
    categoryList: state =>
      state.announcementCategories.map(item => {
        return {
          label: item.name[1],
          value: item.id
        };
      })
  },
  actions: {
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });

      api.getAnnouncementList(query).then(({ data }) => {
        commit('setAnnouncementList', data.list);
        commit('setAnnouncementTotalCount', data.totalCount);
      });
    },
    create(context, data) {
      return api.createAnnouncement(data);
    },
    update(context, data) {
      return api.updateAnnouncement(data);
    },
    remove({ commit }, id) {
      // eslint-disable-line
      return new Promise(resolve => {
        api.removeAnnouncement(id).then(res => {
          resolve(res);
        });
      });
    },
    publish({ commit }, id) {
      // eslint-disable-line
      return new Promise(resolve => {
        api.publishAnnouncement(id).then(res => {
          resolve(res);
        });
      });
    },
    listCategories({ commit }) {
      api.getCategories().then(({ data }) => {
        commit('setAnnouncementCategories', data);
        commit('setAnnouncementCategoriesOrigin', data);
      });
    },
    updateCategories(context, data) {
      return api.updateCategories(data);
    }
  }
};

appStore.registerModule('announcement', store);
